var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-component',_vm._b({attrs:{"primaryKey":"_id","crudNeedsRefresh":_vm.crudNeedsRefresh}},'crud-component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }